import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLabel = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.60927 14.272L1.7226 8.38536C1.47594 8.1387 1.33594 7.7987 1.33594 7.44536L1.33594 2.66536C1.33594 1.93203 1.93594 1.33203 2.66927 1.33203L7.44927 1.33203C7.8026 1.33203 8.1426 1.47203 8.38927 1.72536L14.2759 7.61203C14.7959 8.13203 14.7959 8.9787 14.2759 9.4987L9.49594 14.2787C8.97594 14.7987 8.13594 14.7987 7.60927 14.272ZM13.3359 8.55203L7.44927 2.66536L2.66927 2.66536L2.66927 7.44536L8.55594 13.332L13.3359 8.55203Z",
		fill: "#3C59F6"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.33594 4.33203C5.33594 4.88432 4.88822 5.33203 4.33594 5.33203C3.78365 5.33203 3.33594 4.88432 3.33594 4.33203C3.33594 3.77975 3.78365 3.33203 4.33594 3.33203C4.88822 3.33203 5.33594 3.77975 5.33594 4.33203Z",
		fill: "#3C59F6"
	})]
});
export default SvgLabel;
